export default __webpack_public_path__ + "static/contact-img1400-4b1d218843627bea00d82ffbfd9a40b5.jpg";